module.exports = __webpack_public_path__ + "img/spain-external-causes-male.02a1035e.png";